const rawApiUrl = process.env.REACT_APP_API_URL?.trim() || "/api";
const rawAppType = process.env.REACT_APP_APP_TYPE?.trim() || "sale";

if (rawAppType !== "sale") {
  throw new Error("REACT_APP_APP_TYPE must be sale");
}

export const env = {
  apiUrl: rawApiUrl.replace(/\/$/, ""),
  appType: rawAppType,
  // Keep the client slightly above the reverse proxy's 60-second timeout so
  // that gateway timeout responses reach the UI instead of becoming network errors.
  apiTimeoutMs: 65_000,
} as const;
